// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see SponsoredAccountViewAllStartEvent
 */
export var SponsoredAccountViewAllStart = function (_a) {
    var sponsorCustomerToken = _a.sponsorCustomerToken, numOfSponsoredAccounts = _a.numOfSponsoredAccounts;
    return ({
        name: "SponsoredAccount ViewAll Start",
        parameters: {
            cdf_entity: "SponsoredAccount",
            cdf_action: "ViewAll",
            sponsor_customer_token: sponsorCustomerToken !== undefined && sponsorCustomerToken !== null ? sponsorCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            num_of_sponsored_accounts: numOfSponsoredAccounts !== undefined && numOfSponsoredAccounts !== null ? numOfSponsoredAccounts.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SponsoredAccountInviteFromSponsoredAccountsViewStartEvent
 */
export var SponsoredAccountInviteFromSponsoredAccountsViewStart = function (_a) {
    var sponsorCustomerToken = _a.sponsorCustomerToken;
    return ({
        name: "SponsoredAccount InviteFromSponsoredAccountsView Start",
        parameters: {
            cdf_entity: "SponsoredAccount",
            cdf_action: "InviteFromSponsoredAccountsView",
            sponsor_customer_token: sponsorCustomerToken !== undefined && sponsorCustomerToken !== null ? sponsorCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SponsoredAccountTapSectionItemStartEvent
 */
export var SponsoredAccountTapSectionItemStart = function (_a) {
    var analyticalIdentifier = _a.analyticalIdentifier;
    return ({
        name: "SponsoredAccount TapSectionItem Start",
        parameters: {
            cdf_entity: "SponsoredAccount",
            cdf_action: "TapSectionItem",
            analytical_identifier: analyticalIdentifier !== undefined && analyticalIdentifier !== null ? analyticalIdentifier.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SponsoredAccountManagePendingRequestViewAllEvent
 */
export var SponsoredAccountManagePendingRequestViewAll = function (_a) {
    var numOfPendingRequests = _a.numOfPendingRequests;
    return ({
        name: "SponsoredAccount ManagePendingRequest ViewAll",
        parameters: {
            cdf_entity: "SponsoredAccount",
            cdf_action: "ManagePendingRequest",
            num_of_pending_requests: numOfPendingRequests !== undefined && numOfPendingRequests !== null ? numOfPendingRequests.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SponsoredAccountManagePendingRequestTapOneEvent
 */
export var SponsoredAccountManagePendingRequestTapOne = function (_a) {
    var dependentCustomerToken = _a.dependentCustomerToken, from = _a.from;
    return ({
        name: "SponsoredAccount ManagePendingRequest TapOne",
        parameters: {
            cdf_entity: "SponsoredAccount",
            cdf_action: "ManagePendingRequest",
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            from: from !== undefined && from !== null ? from.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SponsoredAccountManagePendingRequestTapEntryPointToViewAllEvent
 */
export var SponsoredAccountManagePendingRequestTapEntryPointToViewAll = function () { return ({
    name: "SponsoredAccount ManagePendingRequest TapEntryPointToViewAll",
    parameters: {
        cdf_entity: "SponsoredAccount",
        cdf_action: "ManagePendingRequest",
    }
}); };
/**
 * @see SponsoredAccountManageStartEvent
 */
export var SponsoredAccountManageStart = function (_a) {
    var sponsorCustomerToken = _a.sponsorCustomerToken, dependentCustomerToken = _a.dependentCustomerToken;
    return ({
        name: "SponsoredAccount Manage Start",
        parameters: {
            cdf_entity: "SponsoredAccount",
            cdf_action: "Manage",
            sponsor_customer_token: sponsorCustomerToken !== undefined && sponsorCustomerToken !== null ? sponsorCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SponsoredAccountManageNavigateToSettingsEvent
 */
export var SponsoredAccountManageNavigateToSettings = function (_a) {
    var sponsorCustomerToken = _a.sponsorCustomerToken, dependentCustomerToken = _a.dependentCustomerToken;
    return ({
        name: "SponsoredAccount Manage NavigateToSettings",
        parameters: {
            cdf_entity: "SponsoredAccount",
            cdf_action: "Manage",
            sponsor_customer_token: sponsorCustomerToken !== undefined && sponsorCustomerToken !== null ? sponsorCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SponsoredAccountManageLockEvent
 */
export var SponsoredAccountManageLock = function (_a) {
    var sponsorCustomerToken = _a.sponsorCustomerToken, dependentCustomerToken = _a.dependentCustomerToken;
    return ({
        name: "SponsoredAccount Manage Lock",
        parameters: {
            cdf_entity: "SponsoredAccount",
            cdf_action: "Manage",
            sponsor_customer_token: sponsorCustomerToken !== undefined && sponsorCustomerToken !== null ? sponsorCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SponsoredAccountManageUnlockEvent
 */
export var SponsoredAccountManageUnlock = function (_a) {
    var sponsorCustomerToken = _a.sponsorCustomerToken, dependentCustomerToken = _a.dependentCustomerToken;
    return ({
        name: "SponsoredAccount Manage Unlock",
        parameters: {
            cdf_entity: "SponsoredAccount",
            cdf_action: "Manage",
            sponsor_customer_token: sponsorCustomerToken !== undefined && sponsorCustomerToken !== null ? sponsorCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SponsoredAccountManageSendCashEvent
 */
export var SponsoredAccountManageSendCash = function (_a) {
    var sponsorCustomerToken = _a.sponsorCustomerToken, dependentCustomerToken = _a.dependentCustomerToken;
    return ({
        name: "SponsoredAccount Manage SendCash",
        parameters: {
            cdf_entity: "SponsoredAccount",
            cdf_action: "Manage",
            sponsor_customer_token: sponsorCustomerToken !== undefined && sponsorCustomerToken !== null ? sponsorCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SponsoredAccountManageTurnOnStockInvestingEvent
 */
export var SponsoredAccountManageTurnOnStockInvesting = function (_a) {
    var sponsorCustomerToken = _a.sponsorCustomerToken, dependentCustomerToken = _a.dependentCustomerToken;
    return ({
        name: "SponsoredAccount Manage TurnOnStockInvesting",
        parameters: {
            cdf_entity: "SponsoredAccount",
            cdf_action: "Manage",
            sponsor_customer_token: sponsorCustomerToken !== undefined && sponsorCustomerToken !== null ? sponsorCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SponsoredAccountManageTurnOffStockInvestingEvent
 */
export var SponsoredAccountManageTurnOffStockInvesting = function (_a) {
    var sponsorCustomerToken = _a.sponsorCustomerToken, dependentCustomerToken = _a.dependentCustomerToken;
    return ({
        name: "SponsoredAccount Manage TurnOffStockInvesting",
        parameters: {
            cdf_entity: "SponsoredAccount",
            cdf_action: "Manage",
            sponsor_customer_token: sponsorCustomerToken !== undefined && sponsorCustomerToken !== null ? sponsorCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SponsoredAccountManageTurnOnBitcoinInvestingEvent
 */
export var SponsoredAccountManageTurnOnBitcoinInvesting = function (_a) {
    var sponsorCustomerToken = _a.sponsorCustomerToken, dependentCustomerToken = _a.dependentCustomerToken;
    return ({
        name: "SponsoredAccount Manage TurnOnBitcoinInvesting",
        parameters: {
            cdf_entity: "SponsoredAccount",
            cdf_action: "Manage",
            sponsor_customer_token: sponsorCustomerToken !== undefined && sponsorCustomerToken !== null ? sponsorCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SponsoredAccountManageTurnOffBitcoinInvestingEvent
 */
export var SponsoredAccountManageTurnOffBitcoinInvesting = function (_a) {
    var sponsorCustomerToken = _a.sponsorCustomerToken, dependentCustomerToken = _a.dependentCustomerToken;
    return ({
        name: "SponsoredAccount Manage TurnOffBitcoinInvesting",
        parameters: {
            cdf_entity: "SponsoredAccount",
            cdf_action: "Manage",
            sponsor_customer_token: sponsorCustomerToken !== undefined && sponsorCustomerToken !== null ? sponsorCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SponsoredAccountManageTurnOnP2pTransactionsEvent
 */
export var SponsoredAccountManageTurnOnP2pTransactions = function (_a) {
    var sponsorCustomerToken = _a.sponsorCustomerToken, dependentCustomerToken = _a.dependentCustomerToken;
    return ({
        name: "SponsoredAccount Manage TurnOnP2pTransactions",
        parameters: {
            cdf_entity: "SponsoredAccount",
            cdf_action: "Manage",
            sponsor_customer_token: sponsorCustomerToken !== undefined && sponsorCustomerToken !== null ? sponsorCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SponsoredAccountManageTurnOffP2pTransactionsEvent
 */
export var SponsoredAccountManageTurnOffP2pTransactions = function (_a) {
    var sponsorCustomerToken = _a.sponsorCustomerToken, dependentCustomerToken = _a.dependentCustomerToken;
    return ({
        name: "SponsoredAccount Manage TurnOffP2pTransactions",
        parameters: {
            cdf_entity: "SponsoredAccount",
            cdf_action: "Manage",
            sponsor_customer_token: sponsorCustomerToken !== undefined && sponsorCustomerToken !== null ? sponsorCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SponsoredAccountManageToggleDependentControlEvent
 */
export var SponsoredAccountManageToggleDependentControl = function (_a) {
    var dependentControlType = _a.dependentControlType, toggleValue = _a.toggleValue, dependentCustomerToken = _a.dependentCustomerToken;
    return ({
        name: "SponsoredAccount Manage ToggleDependentControl",
        parameters: {
            cdf_entity: "SponsoredAccount",
            cdf_action: "Manage",
            dependent_control_type: dependentControlType !== undefined && dependentControlType !== null ? dependentControlType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            toggle_value: toggleValue !== undefined && toggleValue !== null ? toggleValue.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SponsoredAccountManageTapBalanceEvent
 */
export var SponsoredAccountManageTapBalance = function (_a) {
    var dependentCustomerToken = _a.dependentCustomerToken, balanceType = _a.balanceType;
    return ({
        name: "SponsoredAccount Manage TapBalance",
        parameters: {
            cdf_entity: "SponsoredAccount",
            cdf_action: "Manage",
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            balanceType: balanceType !== undefined && balanceType !== null ? balanceType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SponsoredAccountManageAllowanceSeeNoAllowanceEvent
 */
export var SponsoredAccountManageAllowanceSeeNoAllowance = function (_a) {
    var sponsorCustomerToken = _a.sponsorCustomerToken, dependentCustomerToken = _a.dependentCustomerToken;
    return ({
        name: "SponsoredAccount ManageAllowance SeeNoAllowance",
        parameters: {
            cdf_entity: "SponsoredAccount",
            cdf_action: "ManageAllowance",
            sponsor_customer_token: sponsorCustomerToken !== undefined && sponsorCustomerToken !== null ? sponsorCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SponsoredAccountManageAllowanceStartCreationEvent
 */
export var SponsoredAccountManageAllowanceStartCreation = function (_a) {
    var sponsorCustomerToken = _a.sponsorCustomerToken, dependentCustomerToken = _a.dependentCustomerToken;
    return ({
        name: "SponsoredAccount ManageAllowance StartCreation",
        parameters: {
            cdf_entity: "SponsoredAccount",
            cdf_action: "ManageAllowance",
            sponsor_customer_token: sponsorCustomerToken !== undefined && sponsorCustomerToken !== null ? sponsorCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SponsoredAccountManageAllowanceChangeScheduleEvent
 */
export var SponsoredAccountManageAllowanceChangeSchedule = function (_a) {
    var sponsorCustomerToken = _a.sponsorCustomerToken, dependentCustomerToken = _a.dependentCustomerToken, flowToken = _a.flowToken, isNewAllowance = _a.isNewAllowance;
    return ({
        name: "SponsoredAccount ManageAllowance ChangeSchedule",
        parameters: {
            cdf_entity: "SponsoredAccount",
            cdf_action: "ManageAllowance",
            sponsor_customer_token: sponsorCustomerToken !== undefined && sponsorCustomerToken !== null ? sponsorCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_new_allowance: isNewAllowance !== undefined && isNewAllowance !== null ? isNewAllowance.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SponsoredAccountManageAllowanceEndOnAmountSheetEvent
 */
export var SponsoredAccountManageAllowanceEndOnAmountSheet = function (_a) {
    var sponsorCustomerToken = _a.sponsorCustomerToken, dependentCustomerToken = _a.dependentCustomerToken, flowToken = _a.flowToken, isNewAllowance = _a.isNewAllowance;
    return ({
        name: "SponsoredAccount ManageAllowance EndOnAmountSheet",
        parameters: {
            cdf_entity: "SponsoredAccount",
            cdf_action: "ManageAllowance",
            sponsor_customer_token: sponsorCustomerToken !== undefined && sponsorCustomerToken !== null ? sponsorCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_new_allowance: isNewAllowance !== undefined && isNewAllowance !== null ? isNewAllowance.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SponsoredAccountManageAllowanceEndOnCadenceSelectionEvent
 */
export var SponsoredAccountManageAllowanceEndOnCadenceSelection = function (_a) {
    var sponsorCustomerToken = _a.sponsorCustomerToken, dependentCustomerToken = _a.dependentCustomerToken, flowToken = _a.flowToken, isNewAllowance = _a.isNewAllowance;
    return ({
        name: "SponsoredAccount ManageAllowance EndOnCadenceSelection",
        parameters: {
            cdf_entity: "SponsoredAccount",
            cdf_action: "ManageAllowance",
            sponsor_customer_token: sponsorCustomerToken !== undefined && sponsorCustomerToken !== null ? sponsorCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_new_allowance: isNewAllowance !== undefined && isNewAllowance !== null ? isNewAllowance.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SponsoredAccountManageAllowanceEndOnDayOfCadenceSelectionEvent
 */
export var SponsoredAccountManageAllowanceEndOnDayOfCadenceSelection = function (_a) {
    var sponsorCustomerToken = _a.sponsorCustomerToken, dependentCustomerToken = _a.dependentCustomerToken, flowToken = _a.flowToken, isNewAllowance = _a.isNewAllowance;
    return ({
        name: "SponsoredAccount ManageAllowance EndOnDayOfCadenceSelection",
        parameters: {
            cdf_entity: "SponsoredAccount",
            cdf_action: "ManageAllowance",
            sponsor_customer_token: sponsorCustomerToken !== undefined && sponsorCustomerToken !== null ? sponsorCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_new_allowance: isNewAllowance !== undefined && isNewAllowance !== null ? isNewAllowance.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SponsoredAccountManageAllowanceEndOnDatePickerEvent
 */
export var SponsoredAccountManageAllowanceEndOnDatePicker = function (_a) {
    var sponsorCustomerToken = _a.sponsorCustomerToken, dependentCustomerToken = _a.dependentCustomerToken, flowToken = _a.flowToken, isNewAllowance = _a.isNewAllowance;
    return ({
        name: "SponsoredAccount ManageAllowance EndOnDatePicker",
        parameters: {
            cdf_entity: "SponsoredAccount",
            cdf_action: "ManageAllowance",
            sponsor_customer_token: sponsorCustomerToken !== undefined && sponsorCustomerToken !== null ? sponsorCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_new_allowance: isNewAllowance !== undefined && isNewAllowance !== null ? isNewAllowance.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SponsoredAccountSponsorNotifiedOfMovedEntryPointStartEvent
 */
export var SponsoredAccountSponsorNotifiedOfMovedEntryPointStart = function () { return ({
    name: "SponsoredAccount SponsorNotifiedOfMovedEntryPoint Start",
    parameters: {
        cdf_entity: "SponsoredAccount",
        cdf_action: "SponsorNotifiedOfMovedEntryPoint",
    }
}); };
/**
 * @see SponsoredAccountSponsorNotifiedOfMovedEntryPointNavigateToMoneyTabEvent
 */
export var SponsoredAccountSponsorNotifiedOfMovedEntryPointNavigateToMoneyTab = function () { return ({
    name: "SponsoredAccount SponsorNotifiedOfMovedEntryPoint NavigateToMoneyTab",
    parameters: {
        cdf_entity: "SponsoredAccount",
        cdf_action: "SponsorNotifiedOfMovedEntryPoint",
    }
}); };
/**
 * @see SponsoredAccountReviewActivityTapOneRecentActivityEvent
 */
export var SponsoredAccountReviewActivityTapOneRecentActivity = function (_a) {
    var sponsorCustomerToken = _a.sponsorCustomerToken, dependentCustomerToken = _a.dependentCustomerToken;
    return ({
        name: "SponsoredAccount ReviewActivity TapOneRecentActivity",
        parameters: {
            cdf_entity: "SponsoredAccount",
            cdf_action: "ReviewActivity",
            sponsor_customer_token: sponsorCustomerToken !== undefined && sponsorCustomerToken !== null ? sponsorCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SponsoredAccountReviewActivityTapSeeAllEvent
 */
export var SponsoredAccountReviewActivityTapSeeAll = function (_a) {
    var sponsorCustomerToken = _a.sponsorCustomerToken, dependentCustomerToken = _a.dependentCustomerToken;
    return ({
        name: "SponsoredAccount ReviewActivity TapSeeAll",
        parameters: {
            cdf_entity: "SponsoredAccount",
            cdf_action: "ReviewActivity",
            sponsor_customer_token: sponsorCustomerToken !== undefined && sponsorCustomerToken !== null ? sponsorCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SponsoredAccountReviewActivityTapOneActivityOnFullListEvent
 */
export var SponsoredAccountReviewActivityTapOneActivityOnFullList = function (_a) {
    var sponsorCustomerToken = _a.sponsorCustomerToken, dependentCustomerToken = _a.dependentCustomerToken;
    return ({
        name: "SponsoredAccount ReviewActivity TapOneActivityOnFullList",
        parameters: {
            cdf_entity: "SponsoredAccount",
            cdf_action: "ReviewActivity",
            sponsor_customer_token: sponsorCustomerToken !== undefined && sponsorCustomerToken !== null ? sponsorCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SponsoredAccountStateTransitionedToApprovedForDependentEvent
 */
export var SponsoredAccountStateTransitionedToApprovedForDependent = function (_a) {
    var dependentCustomerToken = _a.dependentCustomerToken;
    return ({
        name: "SponsoredAccount StateTransitionedTo ApprovedForDependent",
        parameters: {
            cdf_entity: "SponsoredAccount",
            cdf_action: "StateTransitionedTo",
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SponsoredAccountStateTransitionedToApprovedBySponsorEvent
 */
export var SponsoredAccountStateTransitionedToApprovedBySponsor = function (_a) {
    var sponsorCustomerToken = _a.sponsorCustomerToken;
    return ({
        name: "SponsoredAccount StateTransitionedTo ApprovedBySponsor",
        parameters: {
            cdf_entity: "SponsoredAccount",
            cdf_action: "StateTransitionedTo",
            sponsor_customer_token: sponsorCustomerToken !== undefined && sponsorCustomerToken !== null ? sponsorCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SponsoredAccountStateTransitionedToRequestedForApprovalEvent
 */
export var SponsoredAccountStateTransitionedToRequestedForApproval = function (_a) {
    var dependentCustomerToken = _a.dependentCustomerToken, sponsorCustomerToken = _a.sponsorCustomerToken;
    return ({
        name: "SponsoredAccount StateTransitionedTo RequestedForApproval",
        parameters: {
            cdf_entity: "SponsoredAccount",
            cdf_action: "StateTransitionedTo",
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            sponsor_customer_token: sponsorCustomerToken !== undefined && sponsorCustomerToken !== null ? sponsorCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SponsoredAccountStateTransitionedToCanceledEvent
 */
export var SponsoredAccountStateTransitionedToCanceled = function (_a) {
    var dependentCustomerToken = _a.dependentCustomerToken, sponsorCustomerToken = _a.sponsorCustomerToken, cancelationReason = _a.cancelationReason;
    return ({
        name: "SponsoredAccount StateTransitionedTo Canceled",
        parameters: {
            cdf_entity: "SponsoredAccount",
            cdf_action: "StateTransitionedTo",
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            sponsor_customer_token: sponsorCustomerToken !== undefined && sponsorCustomerToken !== null ? sponsorCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            cancelation_reason: cancelationReason !== undefined && cancelationReason !== null ? cancelationReason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SponsoredAccountStateTransitionedToCanceledForDependentEvent
 */
export var SponsoredAccountStateTransitionedToCanceledForDependent = function (_a) {
    var dependentCustomerToken = _a.dependentCustomerToken, sponsorCustomerToken = _a.sponsorCustomerToken, cancelationReason = _a.cancelationReason;
    return ({
        name: "SponsoredAccount StateTransitionedTo CanceledForDependent",
        parameters: {
            cdf_entity: "SponsoredAccount",
            cdf_action: "StateTransitionedTo",
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            sponsor_customer_token: sponsorCustomerToken !== undefined && sponsorCustomerToken !== null ? sponsorCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            cancelation_reason: cancelationReason !== undefined && cancelationReason !== null ? cancelationReason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SponsoredAccountCustomerSponsorStatusChangeEvent
 */
export var SponsoredAccountCustomerSponsorStatusChange = function (_a) {
    var isSponsor = _a.isSponsor, updatedAt = _a.updatedAt, numberOfActiveishSponsoredAccounts = _a.numberOfActiveishSponsoredAccounts;
    return ({
        name: "SponsoredAccount CustomerSponsorStatus Change",
        parameters: {
            cdf_entity: "SponsoredAccount",
            cdf_action: "CustomerSponsorStatus",
            is_sponsor: isSponsor !== undefined && isSponsor !== null ? isSponsor.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            updated_at: updatedAt !== undefined && updatedAt !== null ? updatedAt.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            number_of_activeish_sponsored_accounts: numberOfActiveishSponsoredAccounts !== undefined && numberOfActiveishSponsoredAccounts !== null ? numberOfActiveishSponsoredAccounts.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SponsoredAccountGraduateNearingEligibilityEvent
 */
export var SponsoredAccountGraduateNearingEligibility = function (_a) {
    var graduationToken = _a.graduationToken;
    return ({
        name: "SponsoredAccount Graduate NearingEligibility",
        parameters: {
            cdf_entity: "SponsoredAccount",
            cdf_action: "Graduate",
            graduation_token: graduationToken !== undefined && graduationToken !== null ? graduationToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SponsoredAccountGraduateBecameEligibleEvent
 */
export var SponsoredAccountGraduateBecameEligible = function (_a) {
    var graduationToken = _a.graduationToken;
    return ({
        name: "SponsoredAccount Graduate BecameEligible",
        parameters: {
            cdf_entity: "SponsoredAccount",
            cdf_action: "Graduate",
            graduation_token: graduationToken !== undefined && graduationToken !== null ? graduationToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SponsoredAccountGraduateNotificationSentEvent
 *
 * @deprecated This event is deprecated. Use `BecameEligible` instead.
 */
export var SponsoredAccountGraduateNotificationSent = function (_a) {
    var graduationToken = _a.graduationToken, customerToken = _a.customerToken, isReminder = _a.isReminder;
    return ({
        name: "SponsoredAccount Graduate NotificationSent",
        parameters: {
            cdf_entity: "SponsoredAccount",
            cdf_action: "Graduate",
            graduation_token: graduationToken !== undefined && graduationToken !== null ? graduationToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            customer_token: customerToken !== undefined && customerToken !== null ? customerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_reminder: isReminder !== undefined && isReminder !== null ? isReminder.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SponsoredAccountBalanceDetailStartEvent
 */
export var SponsoredAccountBalanceDetailStart = function (_a) {
    var balanceType = _a.balanceType, dependentCustomerToken = _a.dependentCustomerToken;
    return ({
        name: "SponsoredAccount BalanceDetail Start",
        parameters: {
            cdf_entity: "SponsoredAccount",
            cdf_action: "BalanceDetail",
            balance_type: balanceType !== undefined && balanceType !== null ? balanceType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SponsoredAccountBalanceDetailSeeAllActivityEvent
 */
export var SponsoredAccountBalanceDetailSeeAllActivity = function (_a) {
    var balanceType = _a.balanceType, dependentCustomerToken = _a.dependentCustomerToken;
    return ({
        name: "SponsoredAccount BalanceDetail SeeAllActivity",
        parameters: {
            cdf_entity: "SponsoredAccount",
            cdf_action: "BalanceDetail",
            balance_type: balanceType !== undefined && balanceType !== null ? balanceType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SponsoredAccountBalanceDetailSeeActivityEvent
 */
export var SponsoredAccountBalanceDetailSeeActivity = function (_a) {
    var balanceType = _a.balanceType, dependentCustomerToken = _a.dependentCustomerToken, activityItemToken = _a.activityItemToken;
    return ({
        name: "SponsoredAccount BalanceDetail SeeActivity",
        parameters: {
            cdf_entity: "SponsoredAccount",
            cdf_action: "BalanceDetail",
            balance_type: balanceType !== undefined && balanceType !== null ? balanceType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            activity_item_token: activityItemToken !== undefined && activityItemToken !== null ? activityItemToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see SponsoredAccountBalanceDetailGraphTimeUnitChangeEvent
 */
export var SponsoredAccountBalanceDetailGraphTimeUnitChange = function (_a) {
    var balanceType = _a.balanceType, dependentCustomerToken = _a.dependentCustomerToken, timeUnit = _a.timeUnit;
    return ({
        name: "SponsoredAccount BalanceDetail GraphTimeUnitChange",
        parameters: {
            cdf_entity: "SponsoredAccount",
            cdf_action: "BalanceDetail",
            balance_type: balanceType !== undefined && balanceType !== null ? balanceType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            dependent_customer_token: dependentCustomerToken !== undefined && dependentCustomerToken !== null ? dependentCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            time_unit: timeUnit !== undefined && timeUnit !== null ? timeUnit.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
